import { each } from 'lodash';

import { isBlank, isPresent } from 'helpers/string_helpers';
import SimpleFormatter from 'helpers/search_filters/formatters/simple_formatter';

export default class FilterDefinition {
  static types = {
    normal: 'normal',
    boolean: 'boolean',
    range: 'range'
  };

  constructor(options) {
    if (isBlank(options.label)) throw 'label is required';
    if (isPresent(options.type) && !Object.values(FilterDefinition.types).includes(options.type)) {
      throw 'type is invalid';
    }

    this.label = options.label;
    this.type = options.type || FilterDefinition.types.normal;
    this.hideLabel = options.hideLabel;
    this.valueOptions = options.valueOptions || {};
    this.formatter = options.formatter || new SimpleFormatter();
    this.unitSelector = options.unit;

    if (this.isRange()) {
      this.minValueSelector = options.minValue;
      this.maxValueSelector = options.maxValue;
    } else {
      this.valueSelector = options.value;
      this.enumOptions = options.enum;
    }
  }

  isBoolean = () => this.type === FilterDefinition.types.boolean;
  isRange = () => this.type === FilterDefinition.types.range;

  getLabels(query) {
    if (this.isBoolean()) return this.formatBoolean(query);

    let prefix = '';
    if (!this.hideLabel) prefix = `${this.label}: `;

    return this.formatValues(query).map(value => prefix + value);
  }

  formatBoolean(query) {
    const value = this.valueSelector(query);
    if (value) return [this.label];

    return [];
  }

  formatValues(query) {
    let formattedValues = [];

    if (this.isRange()) {
      const minValue = this.minValueSelector(query);
      const maxValue = this.maxValueSelector(query);
      formattedValues.push(this.formatter.formatRange(minValue, maxValue, this.getValueOptions(query)));
    } else {
      const values = this.valueSelector(query);

      if (Array.isArray(values)) {
        each(values, (value) => {
          const formattedValue = this.formatter.format(value, this.getValueOptions(query));
          formattedValues = formattedValues.concat(formattedValue);
        });
      } else {
        formattedValues.push(this.formatter.format(values, this.getValueOptions(query)));
      }
    }

    return formattedValues.filter(value => isPresent(value));
  }

  getValueOptions(query) {
    if (this.unitSelector) {
      let units;
      if (typeof(this.unitSelector) === 'function') {
        units = this.unitSelector(query);
      } else units = this.unitSelector;

      return { ...this.valueOptions, units };
    } else {
      return { ...this.valueOptions, enumOptions: this.enumOptions };
    }
  }
}
